var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-spin',{staticStyle:{"margin-right":"10px"},attrs:{"size":"default"}}),_vm._v(" "+_vm._s(_vm.text))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }